import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { APIService } from 'src/app/core/api/general.service';
import { ItineraryService } from '../services/itinerary.service';
import { OperationLogService } from '../services/operation-log.service';
import { LayoutService } from 'src/app/layout/services/layout.service';
import { OptionType } from 'src/app/core/enums/enums';

function loadAirCompanyNotes(
  pnr: string,
  officeId: string,
  country: string,
  gds: string,
  bookingCode: string,
  api: APIService,
  layoutService: LayoutService,
  operationService: OperationLogService,
  itineraryService: ItineraryService
) {
  return api.getAirCompanyNotes(pnr, officeId, country, gds, bookingCode).pipe(
    map((response) => {
      layoutService.dispatchChangeBreadcrumb(pnr, OptionType.AirCompanyNotes);
      operationService.dispatchLoadAirCompanyNotesSuccess(response);
      return true;
    }),
    catchError((response) => {
      itineraryService.dispatchGenericError(response);
      itineraryService.navigateToWithParams('itinerary/info');
      return of(false);
    })
  );
}

export const AirCompanyNoteGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const api = inject(APIService);
  const itineraryService = inject(ItineraryService);
  const operationService = inject(OperationLogService);
  const layoutService = inject(LayoutService);

  return loadAirCompanyNotes(
    route?.queryParams?.pnr,
    route?.queryParams?.officeId,
    route?.queryParams?.country,
    route?.queryParams?.gds,
    route?.queryParams?.bookingCode,
    api,
    layoutService,
    operationService,
    itineraryService
  );
};
